import { BaseModel } from './base.model';

export enum SkillConfirmationStatus {
  NeedsReview = 0,
  Approved = 1,
  Rejected = 2
}

export interface SkillMatrixEntry extends BaseModel {
  // PersonTechnology data (always present)
  personTechnologyId: number;
  personId: number;
  technologyId: number;
  technologyName: string;
  favourite: boolean;

  // SkillAssessment data (may be null if no assessment exists)
  skillAssessmentId: number | null;
  levelSelfRating: number | null;
  yearsExperience: number | null;
  assessmentDate: string | null;
  assessmentComments: string | null;

  // SkillConfirmation data (may be null if no confirmation exists)
  skillConfirmationId: number | null;
  levelManagerRating: number | null;
  confirmationDate: string | null;
  managerComments: string | null;
  confirmationStatus: SkillConfirmationStatus | null;

  // Computed properties for UI convenience
  hasAssessment: boolean;
  hasConfirmation: boolean;
  needsConfirmation: boolean;
  isConfirmed: boolean;
  isRejected: boolean;
}

export interface CreateSkillAssessmentRequest {
  personId: number;
  personTechnologyId: number;
  levelSelfRating: number;
  yearsExperience?: number | null;
  comments?: string | null;
}

export interface CreateSkillConfirmationRequest {
  assessmentId: number;
  levelManagerRating: number;
  managerComments?: string | null;
  status: SkillConfirmationStatus;
  personId: number;
}

export interface SkillAssessment extends BaseModel {
  personTechnologyId: number;
  levelSelfRating: number;
  yearsExperience: number | null;
  assessmentDate: string;
  comments: string | null;
  personTechnology: {
    technologyId: number;
    technology: any;
    personId: number;
    favourite: boolean;
    projects: any[];
    workExperiences: any[];
    latestSkillAssessment: any;
    latestSkillConfirmation: any;
    skillAssessments: any[];
    id: number;
  };
}

export interface BulkConfirmSkillAssessmentsRequest {
  userId: number;
  personId: number;
  managerComments?: string | null;
  status: SkillConfirmationStatus;
}

export interface PendingConfirmation {
  assessmentId: number;
  levelManagerRating: number;
  confirmationDate: string;
  managerComments: string | null;
  status: SkillConfirmationStatus;
  assessment: {
    personTechnologyId: number;
    levelSelfRating: number;
    yearsExperience: number | null;
    assessmentDate: string;
    comments: string | null;
    personTechnology: {
      technologyId: number;
      technology: {
        name: string;
        categories: any[];
        id: number;
      };
      personId: number;
      favourite: boolean;
      projects: any[];
      workExperiences: any[];
      latestSkillAssessment: any;
      latestSkillConfirmation: any;
      skillAssessments: any[];
      id: number;
    };
    id: number;
  };
  id: number;
}

export interface PersonWithPendingConfirmations {
  personId: number;
  firstName: string;
  lastName: string;
  email: string;
  fullName: string;
  pendingConfirmations: PendingConfirmation[];
  pendingCount: number;
  id: number;
} 